var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCredit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_icon1 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wallet",
    transform: "translate(-422.000000, -692.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_icon1-copy",
    transform: "translate(422.000000, 692.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#009D51",
    cx: 10.5,
    cy: 10.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(5.000000, 4.000000)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.58241758,12 C9.91191523,12 11,10.9421642 11,9.64925373 L11,5.01492537 C11,3.90671642 10.0675039,3 8.9277865,3 L7.73626374,3 C7.54631083,3 7.39089482,3.1511194 7.39089482,3.3358209 C7.39089482,3.52052239 7.54631083,3.67164179 7.73626374,3.67164179 L8.91051805,3.67164179 C9.67032967,3.67164179 10.2919937,4.2761194 10.2919937,5.01492537 L10.2919937,9.66604478 C10.2919937,10.5895522 9.51491366,11.3451493 8.56514914,11.3451493 L2.41758242,11.3451493 C1.4678179,11.3451493 0.690737834,10.5895522 0.690737834,9.66604478 L0.690737834,5.01492537 C0.690737834,4.2761194 1.31240188,3.67164179 2.0722135,3.67164179 L3.24646782,3.67164179 C3.43642072,3.67164179 3.59183673,3.52052239 3.59183673,3.3358209 C3.59183673,3.1511194 3.43642072,3 3.24646782,3 L2.0722135,3 C0.932496075,3 0,3.90671642 0,5.01492537 L0,9.66604478 C0,10.9421642 1.07064364,12 2.41758242,12 L8.58241758,12 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44984671,6.14361702 C3.32964229,6.01595745 3.16936972,6.03191489 3.06252134,6.17553191 C2.969029,6.30319149 2.98238505,6.5106383 3.08923343,6.62234043 L5.31969336,8.92021277 C5.37311755,8.96808511 5.42654174,9 5.49332198,9 C5.56010221,9 5.6135264,8.96808511 5.66695059,8.92021277 L7.91076657,6.62234043 C8.01761495,6.5106383 8.030971,6.30319149 7.93747866,6.17553191 C7.84398633,6.04787234 7.67035771,6.03191489 7.56350933,6.14361702 L5.77379897,7.9787234 L5.77379897,0.319148936 C5.77379897,0.143617021 5.65359455,0 5.50667802,0 C5.3597615,0 5.23955707,0.143617021 5.23955707,0.319148936 L5.23955707,7.9787234 L3.44984671,6.14361702 Z",
    id: "Fill-4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCredit);
export default __webpack_public_path__ + "static/media/ic_credit.2bda9b22cdda8c81a64356fbd52e04d1.svg";
export { ForwardRef as ReactComponent };